// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"4796a8bd","828":"0820a1af"}[chunkId] + ".chunk.js";
};